// extracted by mini-css-extract-plugin
export default {"wrapper":"PrimarySwiper_wrapper__5VGmm","inner":"PrimarySwiper_inner__QFQpx","rowIcon":"PrimarySwiper_rowIcon__T8sMk","btns":"PrimarySwiper_btns__glgF2"};